import { render, staticRenderFns } from "./CrmTags.vue?vue&type=template&id=6e8b0e12&"
import script from "./CrmTags.vue?vue&type=script&lang=js&"
export * from "./CrmTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports